<template>
  <div>
    <!-- slot for parent component to activate the file changer -->
    <div v-cloak @click="launchFilePicker()" @drop.prevent="(e) => onFileChange(uploadFieldName, e.dataTransfer.files)" @dragover.prevent>
      <slot name="activator"></slot>
    </div>
    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
    <input type="file"
       ref="file"
       :name="uploadFieldName"
       @change="(e) => onFileChange(e.target.name, e.target.files)"
       style="display:none">
  </div>
</template>

<script>
export default {
  name: 'image-input',
  data: () => ({
    errorDialog: null,
    errorText: '',
    uploadFieldName: 'image',
    maxSize: 1024
  }),
  props: {
    // Use "value" to enable using v-model
    value: Object,
    imageProps: null
  },
  methods: {
    launchFilePicker () {
      this.$refs.file.click()
    },
    onFileChange (fieldName, file) {
      let imageFile = file[0]
      if (file.length > 0) {
        if (!imageFile.type.match('image.*')) {
          // check whether the upload is an image
          this.errorDialog = true
          this.errorText = 'Veuillez choisir une image'
          this.$refs.file.value = ''
        } else {
          // this.compress(fieldName, imageFile)
          // this.resize(fieldName, imageFile)
          // Append file into FormData and turn file into image URL
          const reader = new FileReader()
          reader.readAsDataURL(imageFile)
          reader.onload = event => {
            const img = new Image()
            img.src = event.target.result
            img.onload = _ => {
              let formData = new FormData()
              let imageURL = URL.createObjectURL(imageFile)
              formData.append(fieldName, imageFile)
              // Emit the FormData and image URL to the parent component
              this.$emit('input', { formData, imageURL, dimension: {w: img.width, h: img.height} })

              this.$refs.file.value = ''
            }
          }
        }
      }
    },
    compress (fieldName, file) {
      if (this.imageProps) {
        if (this.imageProps.size) {
          const fileName = file.name
          const fileType = file.type
          const reader = new FileReader()
          const maxWidth = this.imageProps.size.w
          const maxHeight = this.imageProps.size.h
          reader.readAsDataURL(file)
          reader.onload = event => {
            const img = new Image()
            img.src = event.target.result
            img.onload = () => {
              const elem = document.createElement('canvas')
              const ctx = elem.getContext('2d')
              ctx.webkitImageSmoothingEnabled = false
              ctx.mozImageSmoothingEnabled = false
              ctx.imageSmoothingEnabled = false
              if (img.width > img.height) {
                if (img.width > maxWidth) {
                  const scaleFactor = maxWidth / img.width
                  elem.width = maxWidth
                  elem.height = img.height * scaleFactor
                  ctx.drawImage(img, 0, 0, maxWidth, img.height * scaleFactor)
                }
              } else {
                if (img.height > maxHeight) {
                  const scaleFactor = maxHeight / img.height
                  elem.width = img.width * scaleFactor
                  elem.height = maxHeight
                  ctx.drawImage(img, 0, 0, img.width * scaleFactor, maxHeight)
                }
              }
              ctx.canvas.toBlob((blob) => {
                const compressedFile = new File([blob], fileName, {
                  type: fileType,
                  lastModified: Date.now()
                })
                // Append file into FormData and turn file into image URL
                let formData = new FormData()
                let imageURL = URL.createObjectURL(compressedFile)
                formData.append(fieldName, compressedFile)
                // Emit the FormData and image URL to the parent component
                this.$emit('input', { formData, imageURL })
              }, fileType, 1)
            }
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/imageUploader/imageInput.vue